import { render, staticRenderFns } from "./Anggota.vue?vue&type=template&id=ebef606c&"
import script from "./Anggota.vue?vue&type=script&lang=js&"
export * from "./Anggota.vue?vue&type=script&lang=js&"
import style0 from "./Anggota.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports